import { CustomOrderType } from '../../carts/CustomOrderType';
import { ReplaceEmailInCartResult } from '../../../graphql/cart/replaceEmailInCart';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartReplaceEmailInCartRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly email: string;
  readonly parentActionId: number;
}
export const apiCartReplaceEmailInCartRequestedType = 'api/cart/replaceEmailInCart--requested';
export const apiCartReplaceEmailInCartRequested =
  createAction<ApiCartReplaceEmailInCartRequestedPayload>(apiCartReplaceEmailInCartRequestedType);
export type ApiCartReplaceEmailInCartRequestedAction = ReturnType<
  typeof apiCartReplaceEmailInCartRequested
>;

export interface ApiCartReplaceEmailInCartSucceededPayload {
  readonly cartId: string;
  readonly result: ReplaceEmailInCartResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartReplaceEmailInCartSucceededType = 'api/cart/replaceEmailInCart--succeeded';
export const apiCartReplaceEmailInCartSucceeded =
  createAction<ApiCartReplaceEmailInCartSucceededPayload>(apiCartReplaceEmailInCartSucceededType);
export type ApiCartReplaceEmailInCartSucceededAction = ReturnType<
  typeof apiCartReplaceEmailInCartSucceeded
>;

export interface ApiCartReplaceEmailInCartFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartReplaceEmailInCartFailedType = 'api/cart/replaceEmailInCart--failed';
export const apiCartReplaceEmailInCartFailed = createAction<ApiCartReplaceEmailInCartFailedPayload>(
  apiCartReplaceEmailInCartFailedType
);
export type ApiCartReplaceEmailInCartFailedAction = ReturnType<
  typeof apiCartReplaceEmailInCartFailed
>;
